import trim from "lodash-es/trim";
import { t } from "./i18n";

export const requireRule = [
  {
    validator: (str) => {
      return !!trim(str);
    },
    message: t("不能为空"),
    trigger: "change",
  },
];

export const validateUrl = (url) => {
  const urlPattern =
    /^(https?:\/\/)((([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,})|localhost|(\d{1,3}\.){3}\d{1,3})(:\d+)?(\/[^\s]*)?$/;
  return urlPattern.test(url);
};

export const validateBearerToken = (token) => {
  const tokenPattern = /^[a-zA-Z0-9\-_.=+/ ]+$/;
  return tokenPattern.test(token);
};

export const validateHeaderKey = (key) => {
  const keyPattern = /^[!#$%&'*+\-.0-9A-Za-z^\x60|~]+$/;
  return keyPattern.test(key);
};

export const validateQueryKey = (key) => {
  const keyPattern = /^[a-zA-Z0-9\-_.]+$/;
  return keyPattern.test(key);
};
